(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("belter", [], factory);
	else if(typeof exports === 'object')
		exports["belter"] = factory();
	else
		root["belter"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 